function wpsQueryApi(jsonStr: string) {
  window.wpsQuery?.({
    request: 'fromJSAsynCall("' + jsonStr + '")',
    persistent: false,
  });
}

const appmarketapiCloseEventName = 'builtin.event.queryclose';
const appmarketapiActiveEventName = 'builtin.event.appactived';
const appmarketapiDeactiveEventName = 'builtin.event.appdeactived';

function addListener(eventName: string, callbackName: string) {
  const paramsV = {
    eventName: eventName,
    callbackName: callbackName,
  };

  const JSONStr = JSON.stringify({
    method: 'builtin.event.addEventListener',
    params: paramsV,
  });

  wpsQueryApi(JSONStr);
}

function removeListener(eventName: string) {
  const paramsV = {
    eventName: eventName,
  };

  const JSONStr = JSON.stringify({
    method: 'builtin.event.removeEventListener',
    params: paramsV,
  });

  wpsQueryApi(JSONStr);
}

// 关闭时返回{"code":0}
// 页面跳转前，必须removeCloseListener，可监听 window.addEventListener('beforeunload',()=>{removeCloseListener()})
function addCloseListener(callbackName: string) {
  addListener(appmarketapiCloseEventName, callbackName);
}

// 移除关闭监听
function removeCloseListener() {
  removeListener(appmarketapiCloseEventName);
}

// 判别当前页面是否激活
// {"callstatus":"ok","result":true}
// callstatus为ok接口调用成功
// result为激活状态
function isActive(callbackName: string) {
  const JSONStr = JSON.stringify({
    method: 'builtin.application.isActive',
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 添加页面激活监听
// 激活时回调函数
function addActiveListener(callbackName: string) {
  addListener(appmarketapiActiveEventName, callbackName);
}

// 移除页面激活监听
function removeActiveListener() {
  removeListener(appmarketapiActiveEventName);
}

// 当isActive接口 callstatus为ok 时，才可注册添加
// 添加页面失活监听
// 失活时回调函数
function addDeactiveListener(callbackName: string) {
  addListener(appmarketapiDeactiveEventName, callbackName);
}

// 移除页面失活监听
function removeDeactiveListener() {
  removeListener(appmarketapiDeactiveEventName);
}

// 强制关闭标签页
function closeTab() {
  const JSONStr = JSON.stringify({
    method: 'builtin.application.quit',
  });

  wpsQueryApi(JSONStr);
}

// 判别appid列表
// 输入 appid列表（str 数组） 回调函数名称（str）
// callstatus为ok接口调用成功
// result为ok正常返回信息
// 例：
// 输入 ['AK20210507EQAGJZ', 'kcrm', 'test']
// 返回 {"appInfos":[{"appid":"AK20210507EQAGJZ","exists":true},{"appid":"kcrm","exists":true},{"appid":"test","exists":false}],"callstatus":"ok","result":"ok"}
function isAppListExists(appids: Array<string>, callbackName: string) {
  const params = {
    appids: appids,
  };

  const JSONStr = JSON.stringify({
    method: 'thisapplication.isAppListExists',
    params: params,
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 判别api是否存在
// 输入 函数名称（str 数组） 回调函数名称（str）
// callstatus为ok接口调用成功
// {"bExisted":true,"callstatus":"ok"} bExisted 为true，callstatus为ok，接口存在
// 例：
// 输入 'isAppListExists'
// 返回 {"bExisted":true,"callstatus":"ok"}
function checkApiValid(methodName: string, callbackName: string) {
  const params = {
    methodName: methodName,
  };

  const JSONStr = JSON.stringify({
    method: 'thisapplication.checkApiValid',
    params: params,
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 获取专题列表
// 输入 回调函数名称（str）
// callstatus为ok 接口调用成功 result 为ok 数据返回成功
// {"callstatus":"ok","data":{"grayReleaseInfo":"testUserTag","topics":[{"services":[{"action":"","app_id":"khetong","label":"合同管理"},{"action":"","app_id":"kprojectmgr","label":"项目管理"}],"title":"精选服务"},{"services":[{"action":"","app_id":"kcrm","label":"客户关系管理"}],"title":"最受欢迎"}],"userGroupInfo":"testuserGroup","userTagInfo":"testUserTag"},"result":"ok"}
function getTopicList(callbackName: string) {
  const JSONStr = JSON.stringify({
    method: 'thisapplication.getTopicList',
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 获取banner列表
// 输入 回调函数名称（str）
// callstatus为ok 接口调用成功 result 为ok 数据返回成功
// {"callstatus":"ok","data":{"banner":[{"app_id":1,"app_name":"生产管理解决方案","image_url":"https://vasvip-pub.wpscdn.cn/prod/service_market/solution/trueshengchan_banner_0615.png"},{"app_id":2,"app_name":"行政协同办公解决方案","image_url":"https://vasvip-pub.wpscdn.cn/prod/service_market/solution/xingzheng_banner_0615.png"}],"grayReleaseInfo":"testUserTag","userGroupInfo":"testuserGroup","userTagInfo":"testUserTag"},"result":"ok"}
function getBannerList(callbackName: string) {
  const JSONStr = JSON.stringify({
    method: 'thisapplication.getBannerList',
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 获取banner列表
// 输入 回调函数名称（str）
// callstatus为ok 接口调用成功 result 为ok 数据返回成功
// {"callstatus":"ok","data":{"grayReleaseInfo":"testUserTag","sort":[{"name":"协同办公","services":[{"action":"","app_id":"khetong","label":"合同管理"},{"action":"","app_id":"kprojectmgr","label":"项目管理"}]},{"name":"财务管理","services":[{"action":"","app_id":"kcrm","label":"客户关系管理"}]}],"userGroupInfo":"testuserGroup","userTagInfo":"testUserTag"},"result":"ok"}
function getSortList(callbackName: string) {
  const JSONStr = JSON.stringify({
    method: 'thisapplication.getSortList',
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 获取banner列表
// 输入 回调函数名称（str）
// callstatus为ok 接口调用成功 result 为ok 数据返回成功
// {"callstatus":"ok","data":{"grayReleaseInfo":"testUserTag","rank":[{"config_type":1,"image_url":"https://vasvip-pub.wpscdn.cn/prod/service_market/rightset/yunyinggonggao0401.svg","jump_url":"https://f.wps.cn/w/tdZHH2j5/","services":[],"show_title":0,"show_top_number":0,"title":"心愿单"},{"config_type":0,"image_url":"","jump_url":"","services":[{"action":"","app_id":"khetong","label":"合同管理"},{"action":"","app_id":"kprojectmgr","label":"项目管理"},{"action":"","app_id":"kcrm","label":"客户关系管理"}],"show_title":1,"show_top_number":3,"title":"热度排行"}],"userGroupInfo":"testuserGroup","userTagInfo":"testUserTag"},"result":"ok"}
function getRankList(callbackName: string) {
  const JSONStr = JSON.stringify({
    method: 'thisapplication.getRankList',
    callback: callbackName,
  });

  wpsQueryApi(JSONStr);
}

// 上报数据
// 输入 事件名称(str) 上报对象(json obj)
export function postGeneralEvent(eventName: string, content: Record<string, string | number>) {
  const params = {
    eventName: eventName,
    content: content,
  };

  const JSONStr = JSON.stringify({
    method: 'common.report.dataWarehouseSend',
    params: params,
  });

  wpsQueryApi(JSONStr);
}
